import script from "./NotificationsDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationsDropdown.vue?vue&type=script&setup=true&lang=js"

import "./NotificationsDropdown.vue?vue&type=style&index=0&id=6e5f0fae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e5f0fae"]])

export default __exports__